/**
 * Fallback hero images when plan_stops.image_url is not set.
 * Unsplash (free to use with attribution in prod if needed).
 */
const STOP_IMAGES = {
  'Lago Jasna': 'https://images.unsplash.com/photo-1596436889106-be35e843f974?w=800&q=80',
  'Riserva naturale Zelenci': 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
  'Val Tamar (rifugio)': 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&q=80',
  'Lago Superiore e Inferiore (Laghi di Fusine)': 'https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=800&q=80',
  'Passo Vršič (1.611 m) → Trenta': 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=800&q=80',
  "Sorgente dell'Isonzo (Izvir Soče)": 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=800&q=80',
  'Grande Gola del Soča (Velika korita)': 'https://images.unsplash.com/photo-1509316785289-025f5b846b8f?w=800&q=80',
  'Gola di Vintgar': 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=800&q=80',
  'Lago di Bled': 'https://images.unsplash.com/photo-1596436889106-be35e843f974?w=800&q=80',
  'Funivia Vogel (1.535 m)': 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&q=80',
  'Lago di Bohinj': 'https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=800&q=80',
  'Cascata Peričnik (Mojstrana)': 'https://images.unsplash.com/photo-1434725039720-40a46aaa25d0?w=800&q=80',
  'Centro storico (Piazza Prešeren, Ponte dei Draghi) + Castello': 'https://images.unsplash.com/photo-1527004013197-933c4bb611b3?w=800&q=80',
  'Funivia + seggiovia e villaggi dei pastori (Velika Planina)': 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
  'Grotte di Postumia (trenino)': 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=800&q=80',
  'Castello di Predjama (~9 km da Postumia)': 'https://images.unsplash.com/photo-1527004013197-933c4bb611b3?w=800&q=80',
  'Terme Snovik — piscine termali e scivoli': 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=800&q=80',
  'Logarska dolina e cascata Rinka': 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=800&q=80',
  'Borgo veneziano, Piazza Tartini, mura panoramiche': 'https://images.unsplash.com/photo-1555990798-63c8a7354b23?w=800&q=80',
};

export function resolveStopImage(stop) {
  if (stop.image_url) return stop.image_url;
  return STOP_IMAGES[stop.name] ?? null;
}
